import React, { useState } from 'react';

import { connect } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import { Alert, AlertTitle } from '@material-ui/lab';

import Toggle from '../../../../../../../components/Toggle';

import { createCustomerUser } from '../../../../../../../redux/tracking-manager';

import { CompanyField, S } from './styles';
import { cpfOrCnpjMask } from '../../../../NFFilters/masks';

const NewRecipientForm = ({ 
  onClose, 
  dispatch, 
  currentCustomer, 
  currentNameCompany,
  customerUser 
}) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState();
  const [trackingActive, setTrackingActive] = useState(true);

  const handleSubmit = async () => {
    if ((name, email)) {
      await dispatch(createCustomerUser({
        name,
        email,
        phone,
        trackingActive,
        taxNumber: currentCustomer,
      },
        onClose
      ));
    }
  };

  return (
    <S.FormContent>
      <S.FormTitle>Cadastrar novo destinatário</S.FormTitle>

      <S.Form>
        <TextField
          placeholder="Nome*"
          onChange={e => {
            const value = e.target.value.replace(/[0-9]/g, "");
            setName(value);
          }}
          value={name}
          style={{ marginTop: '48px' }}
          fullWidth
          required
        />

        <TextField
          placeholder="E-mail*"
          fullWidth
          onChange={e => setEmail(e.target.value)}
          style={{ marginTop: '48px' }}
          required
        />

        <TextField
          placeholder="Telefone"
          onChange={e => setPhone(e.target.value)}
          style={{ marginTop: '48px' }}
          fullWidth
        />

        <CompanyField>
          <h4>
            {currentNameCompany}
          </h4>
          <span>
            {cpfOrCnpjMask(currentCustomer.trim())}
          </span>
        </CompanyField>

        <S.TrackingActiveContainer>
          <S.TrackingActive>Ativar/desativar rastreio</S.TrackingActive>
          <S.ToggleContainer>
            <Toggle
              isChecked={trackingActive}
              onChange={() => setTrackingActive(!trackingActive)}
              label={null}
              icon={null}
              small
            />
            <S.CheckBoxLabel checked={trackingActive}>
              Rastreio ativo
            </S.CheckBoxLabel>
          </S.ToggleContainer>
          <S.TrackingDisclaimer>
            Ao ser aprovado, seu destinatário estará com o rastreio ativado.
          </S.TrackingDisclaimer>
        </S.TrackingActiveContainer>
        {customerUser.error && customerUser.error !== '' && (
          <S.WrapperAlert>
            <Alert severity="error">
              <AlertTitle>Erro ao cadastrar</AlertTitle>
              {customerUser.error}
            </Alert>
          </S.WrapperAlert>
        )}
      </S.Form>

      <S.ActionButtonsContainer>
        <S.StyledButton onClick={onClose}>Cancelar</S.StyledButton>
        <S.StyledButton skin="primary" onClick={handleSubmit}>
          Salvar
        </S.StyledButton>
      </S.ActionButtonsContainer>
    </S.FormContent>
  );
};

function mapStateToProps(state) {
  return {
    customerUser: state.trackingManager.customerUser,
  };
}

export default connect(mapStateToProps)(NewRecipientForm);
